// Shared image element for product tiles: swaps to a secondary photo (usually
// gallery[1]) on hover, everywhere a product card is rendered site-wide.
// Parent element must have `relative` + `group` classes.
export const HoverImage = ({ primary, secondary, alt, className = "w-full h-full object-cover" }) => {
  if (!secondary || secondary === primary) {
    return <img src={primary} alt={alt} loading="lazy" className={`${className} transition-transform duration-700 group-hover:scale-105`} />;
  }
  return (
    <>
      <img
        src={primary}
        alt={alt}
        loading="lazy"
        className={`${className} absolute inset-0 transition-all duration-500 group-hover:opacity-0 group-hover:scale-105`}
      />
      <img
        src={secondary}
        alt={alt}
        loading="lazy"
        className={`${className} absolute inset-0 opacity-0 transition-all duration-500 group-hover:opacity-100 group-hover:scale-105`}
      />
    </>
  );
};
